import { useGlobal } from '@/utils/useGlobal';
import styles from './index.module.scss';

export default function P() {
    const { useLang } = useGlobal();
    const { t } = useLang('PowerOcean.P');
    return (
        <div className={`power-ocean-home-P ${styles['power-ocean-home-P']}`}>
            <div className="sec16">{t('text')}</div>
        </div>
    );
}
